// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu3/Item.css
// module id = 2035
// module chunks = 0